module.exports = __webpack_public_path__ + "static/media/Gallery_Grid_9-min.f522dc94.jpg";